var React = require('react');

function Virtuals (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M9,2 L13.184466,12.2498312 L17,2 L18,2 L10.5177994,22 L2,2 L9,2 Z M22,2 L14.5177994,22 L13.5,22 L21,2 L22,2 Z M20,2 L12.5177994,22 L11.5,22 L19,2 L20,2 Z"}));
}

Virtuals.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Virtuals;

Virtuals.default = Virtuals;
